
import PackagePreviewer from './packagePreviewer.vue';
import DcoViewer from './dcoViewer';
import { isPlayable as _isPlayable } from './review.js';
import VideoViewer from './videoViewer.vue';

export default {
  props: {
    material: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    currentDcoList: [Array]
  },
  data: function data() {
    return {
      playbackRate: 1
    };
  },


  components: {
    PackagePreviewer: PackagePreviewer,
    DcoViewer: DcoViewer,
    VideoViewer: VideoViewer
  },

  computed: {
    isPlayable: function isPlayable() {
      return _isPlayable(this.material.creative_type);
    }
  },

  render: function render() {
    var _this = this;

    var h = arguments[0];

    var isGraphic = function isGraphic(type) {
      return Number(type) === 1 || type === 'graphic';
    };
    var isVideo = function isVideo(type) {
      return Number(type) === 2 || type === 'video';
    };
    var getHtml = function getHtml() {
      if (isGraphic(_this.material.creative_type)) {
        return h(
          'img',
          {
            attrs: { src: _this.material.creative_link, alt: '' }
          },
          []
        );
      }

      if (isVideo(_this.material.creative_type)) {
        return h(
          'video-viewer',
          {
            attrs: { material: _this.material }
          },
          []
        );
      }

      if (_this.isPlayable) {
        var url = _this.material.is_ss === 1 ? JSON.parse(_this.material.ext_info).preview_url : _this.material.local_creative_link;
        var hasQuery = url.indexOf('?') !== -1;
        url = url + ((hasQuery ? '&' : '?') + 'preview=true');
        return h(
          'package-previewer',
          {
            attrs: { url: url }
          },
          []
        );
      }

      return null;
    };

    return h(
      'div',
      { 'class': 'material' },
      [getHtml()]
    );
  }
};